import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { GET_ALL_CUSTOMERS } from '@/apollo/schemas/customers/getAllCustomers';
import { useAuth } from '@/context/CoginitoAuthProvider';

import AdminListTable from '../admins/AdminListTable';
import { CustomersTableColumns, TCustomer } from './CustomersTableColumns';

const CustomersTable = () => {
  const { session } = useAuth();
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const authToken = session
    ? session?.getIdToken().getJwtToken()
    : localStorage.getItem('idToken');

  const { data, refetch, loading } = useQuery(GET_ALL_CUSTOMERS, {
    variables: {
      limit: pagination.pageSize,
      offset: pagination.pageIndex * pagination.pageSize,
    },
    context: {
      headers: {
        identity: authToken,
      },
    },
  });

  useEffect(() => {
    refetch({
      limit: pagination.pageSize,
      offset: pagination.pageIndex * pagination.pageSize,
    });
  }, [pagination, refetch]);

  const list = data?.getAllCustomers;

  const rows: TCustomer[] = list?.customers ?? [];
  const total = list?.total ?? 0;

  const handleOpenCustomer = (customer: TCustomer) => {
    navigate(`/admin/customers/${customer.id}`, { state: { customer } });
  };

  return (
    <div className="h-full p-4 border border-secondary rounded-lg bg-white shadow-sm">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold tracking-tight">Customers</h2>
          <p className="text-sm text-muted-foreground">
            View all customers, their wallets, and account activity.
          </p>
        </div>
      </div>
      <AdminListTable
        refetchData={refetch}
        pagination={pagination}
        setPagination={setPagination}
        columns={CustomersTableColumns(handleOpenCustomer, refetch)}
        data={rows}
        rowCount={total}
        isLoadingData={loading}
      />
    </div>
  );
};

export default CustomersTable;
